import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../AuthContext";

import Navbar from "../../components/Navbar.js";
import Card from "../../components/Card.js";
import Popup from "../../components/Popup.js";

import TOILET from "../../assets/toilet-placeholder.jpeg";

import "./Admin.css";

const PLACEHOLDER_TEXT =
  " I recently dined at [RestaurantName] and was thoroughly impressed by both the exquisite cuisine and the impeccable service. The menu showcased a variety of innovative dishes, blending bold flavors and beautiful presentation. The attentive and knowledgeable staff ensured that our meal was a memorable one, providing excellent recommendations and ensuring our satisfaction. I can’t recommend [RestaurantName] enough for a fantastic dining experience.";

const fullCollegeName = (acronym) => {
  const acronymMap = {
    CAS: "College of Arts and Sciences",
    CAFS: "College of Agriculture and Food Science",
    CDC: "College of Development Communication",
    CEM: "College of Economics and Management",
    CEAT: "College of Engineering and Agro-Industrial Technology",
    CFNR: "College of Forestry and Natural Resources",
    CHE: "College of Human Ecology",
    CPAD: "College of Public Affairs and Development",
    CVM: "College of Veterinary Medicine",
    GS: "Graduate School",
    SESAM: "School of Environmental Science and Management",
  };

  return acronymMap[acronym && acronym.toUpperCase()] || acronym;
};

function Admin() {
  // Sample data
  const [data, setData] = useState([]);
  const [usernames, setUsername] = useState({});
  const [reviews, setReviews] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);
  const { loggedIn, user } = useAuth();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const [restroomRes, userRes, reviewsRes] = await Promise.all([
        fetch("https://uplbidet-api.vercel.app/api/cr/pending"),
        fetch("https://uplbidet-api.vercel.app/api/users"),
        fetch("https://uplbidet-api.vercel.app/api/reviews"),
      ]);

      if (!restroomRes.ok || !userRes.ok || !reviewsRes.ok) {
        throw new Error("An error has occurred.");
      }

      const [restroomJson, userJson, reviewsJson] = await Promise.all([
        restroomRes.json(),
        userRes.json(),
        reviewsRes.json(),
      ]);

      setData(restroomJson);

      const usernameMap = {};
      userJson.forEach((user) => {
        usernameMap[user._id] = user.username;
      });
      setUsername(usernameMap);

      const reportedReviews = reviewsJson.filter(
        (review) => review.status === "welp"
      );
      setReviews(reportedReviews);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const openDetailPopup = (cardData) => {
    setSelectedCard(cardData);
    document.body.style.overflow = "hidden";
  };

  const closeDetailPopup = () => {
    setSelectedCard(null);
    document.body.style.overflow = "auto";
  };

  const openReportPopup = (reportData) => {
    setSelectedReport(reportData);
    document.body.style.overflow = "hidden";
  };

  const closeReportPopup = () => {
    setSelectedReport(null);
    document.body.style.overflow = "auto";
  };

  const handleApprove = async () => {
    try {
      const response = await fetch(
        `https://uplbidet-api.vercel.app/api/cr/${selectedCard._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ pending_status: false }),
        }
      );

      if (!response.ok) {
        throw new Error("Error updating bathroom status");
      }

      fetchData();
      closeDetailPopup();
    } catch (error) {
      console.error("Error updating bathroom status: ", error);
    }
  };

  const handleApproveReport = async () => {
    try {
      const response = await fetch(
        `https://uplbidet-api.vercel.app/api/reviews/${selectedReport._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: "All Goods",
            report_reason: "No Report",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Error updating reported review");
      }

      fetchData();
      closeReportPopup();
    } catch (error) {
      console.error("Error updating reported review: ", error);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `https://uplbidet-api.vercel.app/api/cr/${selectedCard._id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Error deleting bathroom");
      }

      fetchData();
      closeDetailPopup();
    } catch (error) {
      console.error("Error deleting bathroom: ", error);
    }
  };

  const handleDeleteReport = async () => {
    try {
      const response = await fetch(
        `https://uplbidet-api.vercel.app/api/reviews/${selectedReport._id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Error deleting reported review");
      }

      fetchData();
      closeReportPopup();
    } catch (error) {
      console.error("Error deleting reported review: ", error);
    }
  };

  function isExternalImage(url) {
    return url && (url.startsWith("https://") || url.startsWith("data:image"));
  }

  const mainPhotoSource = isExternalImage(selectedCard?.main_photo)
    ? selectedCard?.main_photo
    : TOILET;

  const buildingPhotoSource = isExternalImage(selectedCard?.building_photo)
    ? selectedCard?.building_photo
    : TOILET;

  if (user.type === "admin") {
    return (
      <>
        <Navbar passedState={loggedIn} user={user} />

        {/* DETAIL VIEW POP-UP FOR PENDING RESTROOMS */}

        <Popup trigger={selectedCard} onClose={closeDetailPopup}>
          <div className="popup-restroom">
            <h1>PENDING RESTROOM REVIEW</h1>
            <hr />

            <div className="image-holder">
              <img src={mainPhotoSource} alt="toilet image 1" />
              <img src={buildingPhotoSource} alt="toilet image" />
            </div>

            {/* <h2>{selectedCard && selectedCard.college}</h2> */}

            <div className="title-holder">
              <h2>{selectedCard && selectedCard.building.toUpperCase()}</h2>
              <h3>
                {selectedCard &&
                  fullCollegeName(selectedCard.college).toUpperCase()}
              </h3>
            </div>

            <div className="bottom-holder">
              <div className="left-bottom">
                <div className="basic-container">
                  <h3>METADATA</h3>
                  <span>
                    Author: {usernames[selectedCard && selectedCard.user_id]}
                  </span>
                  <span>
                    Time Published:{" "}
                    {selectedCard && selectedCard.time_published}
                  </span>
                </div>

                <div className="basic-container">
                  <h3>DESCRIPTION</h3>
                  <span>{selectedCard && selectedCard.description}</span>
                </div>
              </div>

              <div className="right-bottom">
                <div className="basic-container">
                  <h3>DETAILS:</h3>
                  <div className="table">
                    <div className="tab-left">
                      <span>BIDET:</span>
                      <span>TISSUE PAPER:</span>
                      <span>SOAP:</span>
                      <span>HAND DRYER:</span>
                      <span>TYPE:</span>
                    </div>
                    <div className="tab-right">
                      <span>
                        {selectedCard && selectedCard.bidet ? "YES" : "NO"}
                      </span>
                      <span>
                        {selectedCard && selectedCard.tissue_paper
                          ? "YES"
                          : "NO"}
                      </span>
                      <span>
                        {selectedCard && selectedCard.soap ? "YES" : "NO"}
                      </span>
                      <span>
                        {selectedCard && selectedCard.hand_dryer ? "YES" : "NO"}
                      </span>
                      <span>
                        {selectedCard && selectedCard.pwd_toilet ? "YES" : "NO"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="action">
              <h3>How do you wish to proceed?</h3>
              <div className="button-container">
                <button className="yes" onClick={handleApprove}>
                  APPROVE
                </button>
                <button className="no" onClick={handleDelete}>
                  DELETE
                </button>
              </div>
            </div>
          </div>
        </Popup>

        {/* DETAIL VIEW POP-UP FOR PENDING REPORTS */}

        <Popup trigger={selectedReport} onClose={closeReportPopup}>
          <div className="popup-report">
            <h1>PENDING REPORT</h1>
            <hr />

            <div className="report-details">
              <div className="author_says">
                <div className="author">
                  {selectedReport && selectedReport.author}
                </div>
                <p>says...</p>
              </div>
              <div className="comment">
                <p>
                  {selectedReport &&
                    (selectedReport.comment || PLACEHOLDER_TEXT)}
                </p>
              </div>
              <div className="reason center">
                REASON:{" "}
                {selectedReport && selectedReport.report_reason.toUpperCase()}
              </div>
            </div>

            <div className="action">
              <h3>How do you wish to proceed?</h3>
              <div className="button-container">
                <button
                  className="yes"
                  onClick={() => handleApproveReport(selectedReport)}
                >
                  APPROVE
                </button>
                <button
                  className="no"
                  onClick={() => handleDeleteReport(selectedReport)}
                >
                  DELETE
                </button>
              </div>
            </div>
          </div>
        </Popup>

        <div className="main-content">
          <div className="container">
            <div className="heading">Dashboard</div>
            <div className="hr"></div>

            <div className="top-admin">
              <p className="admin-titles">PENDING RESTROOMS</p>

              {data.length > 0 ? (
                <div className="carousel">
                  {data.map((item) => {
                    return (
                      <div key={item._id} onClick={() => openDetailPopup(item)}>
                        <Card data={item} />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="comment-container">
                  <p>You're all good!</p>
                </div>
              )}
            </div>

            <div className="bottom-admin">
              <div className="comment-container">
                <span className="admin-titles">PENDING REPORTS</span>

                {reviews.length > 0 ? (
                  <div className="scroller">
                    {reviews.map((review) => (
                      <div
                        className="item-review"
                        key={review._id}
                        onClick={() => openReportPopup(review)}
                      >
                        <div className="author_says">
                          <div className="author">{review.author}</div>
                          <p>says...</p>
                        </div>
                        <div className="comment">
                          <p>{review.comment || PLACEHOLDER_TEXT}</p>
                        </div>
                        <div className="reason">
                          REASON: {review.report_reason.toUpperCase()}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="empty">Nothing to review!</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    navigate("/login");
    return null;
  }
}

export default Admin;
